import orgType from '../../config/orgType';
import orgBusinessScope from '../../config/businessScope';

const mixin = {
  data() {
    return {
      Model: {
        orgName: null,
        orgType: null,
        orgDocumentsType: null,
        orgDocumentsNo: null,
        orgDocumentsValidity: null,
        orgQualificationProve: null,
        orgQualificationNo: null,
        orgBusinessScope: null,
        orgRegisterAddress: '',
        orgAddress: '',
        orgRegisteredCapital: null,
        orgController: null,
        isOrgValidateForever: false,
      },
      options: {
        scrollToInvalidField: false,
      },
      Fields: [
        {
          type: 'input',
          modelKey: 'orgName',
          label: '机构名称',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          modelKey: 'orgType',
          label: '机构类型',
          rules: {
            required: true,
          },
          messages: {
            required: '请选择机构类型',
          },
        },
        {
          type: 'input',
          modelKey: 'orgDocumentsType',
          label: '证件类型',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'orgDocumentsNo',
          label: '证件编号',
          props: {
            type: 'tel',
            disabled: true,
          },
        },
        {
          modelKey: 'orgDocumentsValidity',
          label: '证件有效期',
          rules: {
            required: true,
          },
          messages: {
            required: '请选择证件有效期',
          },
        },
        {
          type: 'checkbox',
          modelKey: 'isOrgValidateForever',
          props: {
            option: {
              label: '若为永久有效，请勾选',
            },
            position: 'right',
          },
        },
        {
          type: 'input',
          modelKey: 'orgQualificationProve',
          label: '资质证明',
          props: {
            type: 'text',
            maxlength: 20,
            clearable: true,
            placeholder: '请输入机构资质证明名称,若无则填"无"',
          },
          rules: {
            required: true,
            notWhitespace: true,
            custom: val => val && val.length < 21,
          },
          messages: {
            required: '请输入机构资质证明',
            custom: '长度在20个字符以内',
          },
        },
        {
          type: 'input',
          modelKey: 'orgQualificationNo',
          label: '证书编号',
          props: {
            type: 'text',
            maxlength: 30,
            clearable: true,
            placeholder: '请输入证书编号,若无则填"无"',
          },
          rules: {
            required: true,
            notWhitespace: true,
            custom: val => val && val.length < 31,
          },
          messages: {
            required: '请输入机构资质证书编号',
            custom: '长度在30个字符以内',
          },
        },
        {
          type: 'input',
          modelKey: 'orgRegisteredCapital',
          label: '注册资本(万元)',
          props: {
            clearable: true,
            placeholder: '请输入机构注册资本(万元)',
          },
          rules: {
            type: 'number',
            required: true,
            notWhitespace: true,
          },
          messages: {
            required: '请输入机构注册资本',
          },
        },
        {
          modelKey: 'orgBusinessScope',
          label: '经营范围',
          rules: {
            required: true,
          },
          messages: {
            required: '请选择机构经营范围',
          },
        },
        {
          type: 'input',
          modelKey: 'orgController',
          label: '股东或控股人',
          props: {
            type: 'text',
            maxlength: 50,
            clearable: true,
            placeholder: '请输入机构股东或控股人',
          },
          rules: {
            required: true,
            notWhitespace: true,
          },
          messages: {
            required: '请输入机构股东或控股人',
          },
        },
        {
          type: 'textarea',
          modelKey: 'orgRegisterAddress',
          label: '注册地址',
          props: {
            maxlength: 100,
            disabled: true,
            indicator: false,
            autoExpand: true,
            placeholder: '请输入机构注册地址',
          },
          rules: {
            maxlength: 100,
            notWhitespace: true,
          },
          messages: {
            required: '请输入机构注册地址',
          },
        },
        {
          type: 'textarea',
          modelKey: 'orgAddress',
          label: '办公地址',
          props: {
            maxlength: 100,
            indicator: false,
            placeholder: '请输入机构办公地址',
          },
          rules: {
            required: true,
            notWhitespace: true,
          },
          messages: {
            required: '请输入机构办公地址',
          },
        },
      ],
      selectedIndex: [0],
      selectedBusinessIndex: [0],
    };
  },
  watch: {
    'Model.isOrgValidateForever': {
      handler(val) {
        if (val) {
          this.Model.orgDocumentsValidity = '永久有效';
        } else {
          this.Model.orgDocumentsValidity = null;
        }
      },
      immediate: false,
    },
  },
  methods: {
    /**
     * 选择机构类型
     * @return {[type]} [description]
     */
    $_handleShowOrgTypePicker() {
      const column = orgType[this.managerInfo.invenstemType];
      this.$createPicker({
        title: '机构类型',
        data: [column],
        selectedIndex: this.selectedIndex,
        onSelect: (selectedVal, selectedIndex) => {
          this.$set(this.Model, 'orgType', selectedVal[0]);
          this.$set(this, 'selectedIndex', selectedIndex);
        },
        onCancel: () => {
        },
      }).show();
    },
    /**
     * 选择证件有效期
     * @return {[type]} [description]
     */
    $_handleShowOrgDocumentsValidityPicker() {
      if (this.Model.isOrgValidateForever) return;
      this.$createDatePicker({
        title: '证件有效期',
        min: new Date(1999, 12, 1),
        max: new Date(2099, 11, 31),
        format: {
          year: 'YYYY',
          month: 'MM',
          date: 'DD',
        },
        value:
          this.Model.orgDocumentsValidity
            ? new Date(this.Model.orgDocumentsValidity)
            : new Date(),
        onSelect: (date, selectedVal, selectedText) => {
          this.$set(this.Model, 'orgDocumentsValidity', selectedText.join('-'));
        },
        onCancel: () => {
        },
      }).show();
    },
    /**
     * 选择经营范围
     * @return {[type]} [description]
     */
    $_handleShowOrgBusinessScopePicker() {
      this.$createPicker({
        title: '经营范围',
        data: [orgBusinessScope],
        position: 'right',
        selectedIndex: this.selectedBusinessIndex,
        onSelect: (selectedVal, selectedIndex) => {
          this.$set(this.Model, 'orgBusinessScope', selectedVal[0]);
          this.$set(this, 'selectedBusinessIndex', selectedIndex);
        },
        onCancel: () => {
        },
      }).show();
    },
  },
};
export default mixin;
